var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('button',{staticClass:"normal-btn",on:{"click":function($event){return _vm.$emit('normalBtn')}}},[_vm._v(" "+_vm._s(_vm.nameBtn)+" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }